<template>
  <div class="detail">
    <van-form>
      <van-field
        v-model="form.name"
        :disabled="disabled"
        name="name"
        label="姓名"
        placeholder=""
      />
      <van-field name="gender" label="性别" :disabled="disabled" >
        <template #input>
          <van-radio-group v-model="form.gender" :disabled="disabled" direction="horizontal">
            <van-radio name="1">男</van-radio>
            <van-radio name="2">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        readonly
        clickable
        name="birthday"
        :disabled="disabled"
        :value="form.birthday"
        label="出生日期"
        placeholder="点击选择日期"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-datetime-picker
          type="date"
          @confirm="onSelectBirthday"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-field
        v-model="form.id_number"
        :disabled="disabled"
        name="id_number"
        label="身份证号"
        placeholder="身份证号"
      />
      <van-field
        v-model="form.telephone"
        :disabled="disabled"
        name="telephone"
        label="手机号"
        type="digit"
        placeholder="手机号"
        :rules="[{ pattern: /^1\d{10}$/,required: true, message: '请填写正确手机号' }]"
      />
      <van-field name="category" label="报名项目" :disabled="disabled" >
        <template #input>
          <van-radio-group v-model="form.category" :disabled="disabled" direction="horizontal">
            <van-radio name="1">悦跑组</van-radio>
            <van-radio name="2">健步组</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field name="size" label="服装尺寸" :disabled="disabled" >
        <template #input>
          <van-radio-group v-model="form.size" :disabled="disabled" direction="horizontal">
            <van-radio name="S">S</van-radio>
            <van-radio name="M">M</van-radio>
            <van-radio name="L">L</van-radio>
            <van-radio name="XL">XL</van-radio>
            <van-radio name="XXL">XXL</van-radio>
            <van-radio name="XXXL">XXXL</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="form.name2"
        :disabled="disabled"
        name="name2"
        label="紧急联系人姓名"
        placeholder=""
      />
      <van-field
        v-model="form.telephone2"
        :disabled="disabled"
        name="telephone2"
        label="紧急联系人手机号"
        type="digit"
        placeholder="紧急联系人手机号"
      />
      <div v-if="canRefresh" style="margin: 16px;padding-bottom: 2rem;">
        <van-button round :disabled="refreshing" block type="info" @click.stop="getForm">{{ refreshing ? '正在刷新...': '点击刷新' }}</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import axios from 'axios'
import { util,mc } from '../../assets/common2.js'
import { ImagePreview } from 'vant'
export default {
  name: 'RunnerDetail',
  props: {
  },
  data () {
    return {
      loading: false,
      form: {
        name:'',
        telephone: '',
        birthday: null,
        address: '',
        id_number: '',
        gender: '',
        category: '',
        size: '',
        name2:'',
        telephone2: '',
      },
      disabled: true,
      pdf_contract: []
    }
  },
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
    // CommentComponent
  },
  computed: {
  },
  created: function () {
    if (!mc.isClient()) {
      this.$router.replace('/runner/index')
    }
    this.form_id = this.$route.params.form_id
    this.fid = this.$store.state.fid
  },
  mounted: function () {
    this.getDetail()
  },
  methods: {
    preview(img,index) {
      var images = img.split(',')
      ImagePreview({
        images,
        startPosition: index,
      })
    },
    getDetail() {
      this.refreshing = true
      util.Arequest((data) => {
        var formData = new FormData()
        formData.append('form_id',this.form_id)
        formData.append('token',data.token)
        formData.append('userid',data.userid)
        axios.post(`/encrypt3/form/detail?fid=${this.fid}&start=0&size=50`,formData).then(res => {
            if (res.data.msg == 'ok') {
              this.form = res.data.form
              this.form.gender = this.form.gender + ''
              this.form.category = this.form.category + ''
              this.canRefresh = false
              this.loading = false;
            } else if (res.data.msg == 'not admin') {
              this.$toast('无权限')
            } else if (res.data.msg == 'not exists') {
              this.$toast('没有该申请')
            } else if (res.data.msg == 'error merchant') {
              this.$toast('非法请求')
            } else {
              this.canRefresh = true
              this.$toast('网络繁忙\n稍后重试')
            }
            this.refreshing = false
          }).catch(() => {
            this.canRefresh = true
            this.refreshing = false
            this.$toast('网络繁忙\n稍后重试')
          })
      })
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .main {
  margin-top: 56.3vw;
} */
.reject {
  background-color: aqua;
  padding-top: 0.5rem;
}
.reject-reason {
  width: 90%;
  margin: auto;
  text-align: left;
  line-height: 1.4rem;
}
.upload-img {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}
.upload-icon {
  width: 28%;
  margin: 3px 3px;
}
</style>
